import { render, staticRenderFns } from "./cabin-master.vue?vue&type=template&id=43fe5fce"
import script from "./cabin-master.vue?vue&type=script&lang=js"
export * from "./cabin-master.vue?vue&type=script&lang=js"
import style0 from "./cabin-master.vue?vue&type=style&index=0&id=43fe5fce&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports